'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { Stamp } from '@src/components/TopNavV5/Stamp';
import { useTopNavV5 } from '@src/components/TopNavV5/TopNavV5Context';
import { TopNavV5MobileFooter } from '@src/components/TopNavV5/TopNavV5Mobile/TopNavV5MobileFooter';
import type { TopNavV5MenuItem } from '@src/components/TopNavV5/TopNavV5Props';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
import { cn } from '@src/utils/tailwind';
export const TopNavV5MobileMenu = () => {
  const $ = _c(9);
  const trackSelectNavCta = useTrackSelectNavCta();
  const {
    items,
    mobileDispatch
  } = useTopNavV5();
  const renderTitle = _temp;
  let t0;
  if ($[0] !== items || $[1] !== mobileDispatch || $[2] !== trackSelectNavCta) {
    t0 = items?.map((item, index) => {
      if (item.subMenuType === "link") {
        return <LocalizedLink onClick={() => {
          trackSelectNavCta({
            "cta url": item.link?.href ?? ""
          });
          mobileDispatch({
            type: "CLOSE_FROM_MAIN"
          });
        }} data-testid={`nav-menu-${index}`} key={`${item.title}-${index}`} className="py-3 text-heading-4 font-lateral font-medium text-left" href={item.link?.href ?? ""} rel={item.link?.newTab ? "noopener noreferrer" : ""} target={item.link?.newTab ? "_blank" : "_self"}>{renderTitle(item)}</LocalizedLink>;
      }
      return <button data-testid={`nav-menu-${index}`} key={`${item.title}-${index}`} className={cn("py-3 text-heading-4 font-lateral font-medium text-left", "relative flex w-full cursor-pointer items-center gap-2 transition-all")} onClick={() => {
        if (item.subMenuType === "leftMenu") {
          mobileDispatch({
            type: "OPEN_LEFT_MENU",
            payload: {
              leftMenu: {
                title: item.title ?? "",
                stamp: item.stamp ?? "",
                items: item.leftMenuItems ?? []
              }
            }
          });
        } else {
          if (item.subMenuType === "subMenu") {
            mobileDispatch({
              type: "OPEN_SUB_MENU",
              payload: {
                subMenu: item.subMenu ?? null,
                miniMenu: null
              }
            });
          } else {
            if (item.subMenuType === "miniMenu") {
              mobileDispatch({
                type: "OPEN_SUB_MENU",
                payload: {
                  subMenu: null,
                  miniMenu: {
                    title: item.title ?? "",
                    items: item.miniMenuItems ?? []
                  }
                }
              });
            }
          }
        }
      }}>{renderTitle(item)}<ChevronRightIcon className="size-5 text-bodi-accent-bright-500" /></button>;
    });
    $[0] = items;
    $[1] = mobileDispatch;
    $[2] = trackSelectNavCta;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== t0) {
    t1 = <div className="flex flex-col gap-2 px-4 py-6 pt-4">{t0}</div>;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TopNavV5MobileFooter />;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1) {
    t3 = <>{t1}{t2}</>;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
function _temp(menu) {
  return <div className="flex w-fit items-center gap-2">{menu.title}<Stamp text={menu.stamp} /></div>;
}